import React from 'react';

function useMenu(currentPath: string) {
  const isActive = (path: string) => {
    return currentPath.includes(path) || currentPath === path;
  };

  return { isActive };
}

export default useMenu;
